import React from 'react';
import PropTypes from 'prop-types';

import { List } from '../components/List';
import ProjectItem from './components/ProjectItem';

const ProjectsList = ({ projects, isGrid, selectProject }) => (
  <List isGrid={isGrid} data-test="list">
    {projects.map(project => (
      <ProjectItem
        key={project.id}
        project={project}
        isGrid={isGrid}
        selectProject={selectProject}
      />
    ))}
  </List>
);

ProjectsList.propTypes = {
  isGrid: PropTypes.bool.isRequired,
  projects: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectProject: PropTypes.func.isRequired,
};

export default ProjectsList;
